/*
 * @Author:
 * @Date: 2022-07-01 08:53:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-01 15:52:21
 * @FilePath: /Cup2Market/src/api/searchSetting.js
 * @Description:
 */
import request from "@/utils/request";

export function getHotWords() {
  return request({
    url: "/product/search/hot-words",
    method: "get",
  });
}

export function getHotGoods() {
  return request({
    url: "/product/search/hot-goods/h5",
    method: "get",
  });
}

export function getHotBrand() {
  return request({
    url: "/product/search/hot-brands/h5",
    method: "get",
  });
}
